import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cb27ceb3: FaireBrandEntity = {
  token: "b_cb27ceb3",
  type: "brand",
  name: "Old Whaling Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/fc9c7ff4b6209cab284c33a775824ec07b2ff9733139e6307ca5371e7bd00788.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c0c8b90f71df09137b77beabc3e8e8a99de1904ef56374732c39574221448343.png",
  logoUrl:
    "https://cdn.faire.com/fastly/fc9c7ff4b6209cab284c33a775824ec07b2ff9733139e6307ca5371e7bd00788.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c0c8b90f71df09137b77beabc3e8e8a99de1904ef56374732c39574221448343.png",
  location: "Charleston, SC, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 600,
  isTopShop: true,
  isInsider: true,
  description:
    "Old Whaling Company is a woman-owned bath and home brand based in Charleston, South Carolina. Founded in 2012, our belief is that high quality, handcrafted bath products can be beautiful and nourishing without compromising on gentle ingredients or cherished fragrances. \n\nWe handcraft our products with the utmost care and attention to detail, with a mission to provide gentle yet effective alternatives for your body care routine. Our hope is that our products leave you feeling fresh, clean, and a little closer to your favorite coast.\n\nAll products are phthalate free, paraben-free, mineral oil free, and never tested on animals.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:09.515Z",
    importedBy: "entity-db-cli",
  },
};
